// extracted by mini-css-extract-plugin
export default {"El":"Title_El__0NgJo","Title":"Title_Title__TZ6k0","Options":"Title_Options__rXT4h","Option":"Title_Option__OfcPG","isSelected":"Title_isSelected__hhaD+"};